import { GridRowSelectionModel } from '@mui/x-data-grid-pro';

import { usePagamentoContext } from '../contexts/PagamentoContext';

import { CondicaoPagamento } from 'pages/complementar/condicao-pagamento/types';

export function useActionsPagamento() {
    const {
        isPending,
        idsPedido,
        setIdPedido,
        isFinishing,
        setIdsPedido,
        cartoesCredito,
        setCartoesCredito,
        selecaoMeioPagamento,
        setSelecaoMeioPagamento,
    } = usePagamentoContext();

    /**
     * Atualiza o cartao de crédito selecionado com a condição de pagamento informada.
     */
    const updateSelectedCondicaoPagamentoInCartaoCredito = (condicaoPagamento: CondicaoPagamento) => {
        if (!selecaoMeioPagamento) {
            return;
        }

        const newCartoesCredito = cartoesCredito.map((cartao) => {
            if (cartao.idCartaoPagamento === selecaoMeioPagamento?.cartaoPagamento?.idCartaoPagamento) {
                return { ...cartao, condicaoPagamento };
            }

            return cartao;
        });

        setSelecaoMeioPagamento({ ...selecaoMeioPagamento, condicaoPagamento });

        setCartoesCredito(newCartoesCredito);
    };

    /**
     * Retorna a seleção para a grid, caso ela for do tipo cartão de crédito.
     */
    const getSelectionGrid = (): GridRowSelectionModel => {
        const isSelecaoCartaoCredito = selecaoMeioPagamento?.meioPagamentoEnum === 'CARTAO_CREDITO';

        if (isSelecaoCartaoCredito && selecaoMeioPagamento.cartaoPagamento?.idCartaoPagamento) {
            return {
                type: 'include',
                ids: new Set([selecaoMeioPagamento.cartaoPagamento.idCartaoPagamento]),
            };
        }

        return {
            type: 'include',
            ids: new Set(),
        };
    };

    /**
     * Ao clicar na linha, define a seleção como o cartão de crédito clicado.
     */
    const onClickRowGrid = (selectionModel: GridRowSelectionModel) => {
        if (selectionModel.ids.size && !isPending && !isFinishing) {
            const cartao = cartoesCredito.find((cartao) => cartao.idCartaoPagamento === Array.from(selectionModel.ids).at(-1));

            if (cartao && cartao?.condicaoPagamento) {
                setSelecaoMeioPagamento({
                    meioPagamentoEnum: 'CARTAO_CREDITO',
                    cartaoPagamento: cartao,
                    condicaoPagamento: cartao.condicaoPagamento,
                });
            }
        }
    };

    /**
     * Atualiza o idPedido para o próximo da lista de ids.
     */
    const setNextIdPedido = () => {
        const newIdsPedido = idsPedido.slice(1);
        const newIdPedido = newIdsPedido[0];

        setIdsPedido(newIdsPedido);

        if (newIdPedido) {
            setIdPedido(newIdPedido);
        }
    };

    return {
        onClickRowGrid,
        setNextIdPedido,
        getSelectionGrid,
        updateSelectedCondicaoPagamentoInCartaoCredito,
    };
}
